const GTM_EVENT_NAME = "registro_BdB_submit";
const META_EVENT_NAME = "registro_BdB";
const TIKTOK_EVENT_NAME = "c";
const GOOGLE_ADS_SEND_TO = "AW-928770564/uK1KCO7WxugbEITU77oD";

function getWindow() {
  if (typeof window === "undefined") {
    return null;
  }

  return window;
}

function ensureDataLayer(win) {
  if (!Array.isArray(win.dataLayer)) {
    win.dataLayer = [];
  }

  return win.dataLayer;
}

function pushDataLayer(win, payload) {
  try {
    ensureDataLayer(win).push(payload);
    return true;
  } catch (error) {
    console.error("No se pudo enviar el evento a dataLayer", error);
    return false;
  }
}

function getParentOrigin(win) {
  try {
    if (!win.document.referrer) {
      return null;
    }

    return new URL(win.document.referrer).origin;
  } catch (error) {
    console.error("No se pudo resolver el origen de la pagina padre", error);
    return null;
  }
}

function postMessageToParent(win, payload) {
  try {
    if (!win.parent || win.parent === win) {
      return false;
    }

    const targetOrigin = getParentOrigin(win);

    if (!targetOrigin) {
      return false;
    }

    win.parent.postMessage(
      {
        type: "bg_marketing_event",
        source: "enginev2-bancoBarrio",
        payload,
      },
      targetOrigin
    );

    return true;
  } catch (error) {
    console.error("No se pudo enviar el evento al iframe padre", error);
    return false;
  }
}

export async function trackBancoBarrioSubmit(payload = {}) {
  const win = getWindow();

  if (!win) {
    return {
      dataLayer: false,
      parentMessage: false,
      meta: false,
      tiktok: false,
      googleAds: false,
    };
  }

  const eventPayload = {
    event: GTM_EVENT_NAME,
    form_name: "bancoBarrio",
    form_status: "success",
    ...payload,
  };

  const results = {
    dataLayer: pushDataLayer(win, eventPayload),
    parentMessage: postMessageToParent(win, eventPayload),
    meta: false,
    tiktok: false,
    googleAds: false,
  };

  try {
    if (typeof win.fbq === "function") {
      win.fbq("trackCustom", META_EVENT_NAME);
      results.meta = true;
    }
  } catch (error) {
    console.error("No se pudo enviar el evento a Meta Pixel", error);
  }

  try {
    if (win.ttq && typeof win.ttq.track === "function") {
      win.ttq.track(TIKTOK_EVENT_NAME);
      results.tiktok = true;
    }
  } catch (error) {
    console.error("No se pudo enviar el evento a TikTok Pixel", error);
  }

  try {
    if (typeof win.gtag === "function") {
      win.gtag("event", "conversion", {
        send_to: GOOGLE_ADS_SEND_TO,
      });
      results.googleAds = true;
    }
  } catch (error) {
    console.error("No se pudo enviar el evento a Google Ads", error);
  }

  return results;
}

export { GOOGLE_ADS_SEND_TO, GTM_EVENT_NAME, META_EVENT_NAME, TIKTOK_EVENT_NAME };
